import React from 'react'
import fp from 'lodash/fp'
import { Route, Redirect, Switch } from 'react-router-dom'
import { getDisplayName } from 'utils/tools/react-tools'

const { Fragment } = React
const KeyIsModalRoute = Symbol('Modal:Route')

const createRoutes = (routesFn, options) => {
  options = {
    switched: false,
    layout: null,
    ...options,
  }

  const Layout = options.layout
  const Container = options.switched ? Switch : Fragment

  const transformToRoute = (params) => {
    if (params.redirect) {
      return <Redirect {...params.redirect} key={`redirect_${params.to}`} />
    }

    return (
      <Route
        {...params}
        key={params.path || getDisplayName(params.component)}
      />
    )
  }

  const GeneratedRoutes = (params) => {
    const allRoutes = React.useMemo(() => {
      return fp.map(transformToRoute, routesFn(params))
    }, [])

    return <Container>{allRoutes}</Container>
  }

  if (fp.isFunction(Layout)) {
    const Wrapped = (props) => {
      return (
        <Layout {...props}>
          <GeneratedRoutes {...props} />
        </Layout>
      )
    }

    return Wrapped
  }

  return GeneratedRoutes
}

export default createRoutes
export { KeyIsModalRoute }
